import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_GREY_9 } from "shared/theme/colors";
import { ReplayIcon } from "shared/theme/icons/ReplayIcon";
import { StyledClearButton } from "./styled";

type ClearButtonProps = {
  onClearFilters: () => void;
};

const ClearButton: FC<ClearButtonProps> = ({ onClearFilters }) => {
  return (
    <StyledClearButton onClick={onClearFilters}>
      <ReplayIcon color={COLOR_GREY_9} size={20} />
      <Typography variant="bodyMMedium">Clear filter</Typography>
    </StyledClearButton>
  );
};

export default ClearButton;
